export const MUTATION_TRAINING_TYPES = 'MUTATION_TRAINING_TYPES'

export default {
  [MUTATION_TRAINING_TYPES](state, payload) {
    state.trainingTypes = payload
  }
}
